import React, { useState } from 'react';
import { X } from 'lucide-react';

export function NewSidebarSettings() {
  const [subTasks, setSubTasks] = useState<string[]>([]);
  const [isAddingTask, setIsAddingTask] = useState(false);
  const [newTaskName, setNewTaskName] = useState('');

  const handleAddTask = () => {
    if (newTaskName.trim()) {
      setSubTasks([...subTasks, newTaskName.trim()]);
      setNewTaskName('');
    }
    setIsAddingTask(false);
  };
  return (
    <div className="space-y-4">
      <div className="bg-white rounded-md border border-slate-100 overflow-hidden">
        <div className="p-3 border-b border-slate-50 flex items-center justify-between bg-slate-50/30">
          <h3 className="sm:text-sm text-xs text-slate-800">Cài đặt nâng cao</h3>
          <i className="ri-arrow-up-s-line text-slate-400" />
        </div>
        
        <div className="p-3 space-y-4">
          <div className="space-y-1">
            <label className="sm:text-sm text-xs text-slate-500">Điều kiện hoàn thành</label>
            <div className="relative">
              <textarea 
                placeholder="Nhập điều kiện để công việc được đánh dấu hoàn thành"
                className="w-full h-24 p-2 rounded-md border border-slate-200 sm:text-sm text-xs bg-slate-50/50 resize-none focus:outline-none focus:ring-1 focus:ring-emerald-500"
                maxLength={500}
              />
              <span className="absolute right-2 bottom-2 sm:text-sm text-xs text-slate-400">0/500</span>
            </div>
          </div>

          <div className="space-y-2">
            <label className="sm:text-sm text-xs text-slate-500">Công việc con</label>
            {subTasks.length > 0 && (
              <div className="space-y-2 mb-2">
                {subTasks.map((task, idx) => (
                  <div key={idx} className="flex items-center justify-between rounded-md border border-slate-200 bg-slate-50 px-2 py-1.5">
                    <span className="sm:text-sm text-xs text-slate-700">{task}</span>
                    <button type="button" onClick={() => setSubTasks(subTasks.filter((_, i) => i !== idx))} className="text-slate-400 hover:text-rose-500">
                      <X className="h-4 w-4" />
                    </button>
                  </div>
                ))}
              </div>
            )}
            
            {isAddingTask ? (
              <div className="flex flex-col gap-2">
                <input
                  autoFocus
                  type="text"
                  value={newTaskName}
                  onChange={(e) => setNewTaskName(e.target.value)}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddTask(); } }}
                  placeholder="Nhập tên công việc con..."
                  className="h-8 w-full rounded-md border border-emerald-500 px-2 sm:text-sm text-xs outline-none"
                />
                <div className="flex items-center gap-2">
                  <button type="button" onClick={handleAddTask} className="rounded-md bg-emerald-600 px-3 py-1 sm:text-sm text-xs text-white hover:bg-emerald-700">Lưu</button>
                  <button type="button" onClick={() => { setIsAddingTask(false); setNewTaskName(''); }} className="rounded-md bg-slate-100 px-3 py-1 sm:text-sm text-xs text-slate-600 hover:bg-slate-200">Hủy</button>
                </div>
              </div>
            ) : (
              <button type="button" onClick={() => setIsAddingTask(true)} className="flex items-center gap-1 sm:text-sm text-xs text-emerald-600 hover:underline">
                <i className="ri-add-line" /> Thêm công việc
              </button>
            )}
          </div>

          <div className="space-y-2">
            <label className="sm:text-sm text-xs text-slate-500">Vật tư</label>
            <button type="button" className="flex items-center gap-1 sm:text-sm text-xs text-emerald-600 hover:underline">
              <i className="ri-add-line" /> Thêm vật tư
            </button>
          </div>

          <div className="space-y-2">
            <label className="sm:text-sm text-xs text-slate-500">Thiết bị</label>
            <button type="button" className="flex items-center gap-1 sm:text-sm text-xs text-emerald-600 hover:underline">
              <i className="ri-add-line" /> Thêm thiết bị
            </button>
          </div>

          <div className="pt-2 border-t border-slate-50 flex items-center justify-between">
            <label className="sm:text-sm text-xs text-slate-700">Nhắc việc</label>
            <div className="w-10 h-5 bg-emerald-600 rounded-full relative">
              <div className="w-4 h-4 bg-white rounded-full absolute right-0.5 top-0.5" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div className="space-y-1">
              <label className="sm:text-sm text-xs text-slate-400">Nhắc trước</label>
              <select className="w-full h-8 px-2 rounded-md border border-slate-200 sm:text-sm text-xs bg-white">
                <option>1 ngày</option>
              </select>
            </div>
            <div className="space-y-1">
              <label className="sm:text-sm text-xs text-slate-400">Kênh thông báo</label>
              <select className="w-full h-8 px-2 rounded-md border border-slate-200 sm:text-sm text-xs bg-white">
                <option>Thông báo hệ thống</option>
              </select>
            </div>
          </div>

          <div className="space-y-2">
            <label className="sm:text-sm text-xs text-slate-500">Nhãn</label>
            <button type="button" className="flex items-center gap-1 sm:text-sm text-xs text-emerald-600 hover:underline">
              <i className="ri-add-line" /> Thêm nhãn
            </button>
          </div>

          <div className="pt-4 border-t border-slate-50 space-y-3">
            <h4 className="sm:text-sm text-xs text-slate-400 tracking-wider">Tùy chọn khác</h4>
            <div className="space-y-2">
              <OptionCheckbox label="Cho phép cập nhật tiến độ" checked={true} />
              <OptionCheckbox label="Cho phép đính kèm tài liệu" checked={true} />
              <OptionCheckbox label="Yêu cầu xác nhận khi hoàn thành" checked={false} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function OptionCheckbox({ label, checked }: { label: string, checked: boolean }) {
  return (
    <label className="flex items-center gap-2 cursor-pointer group">
      <div className={`w-4 h-4 rounded flex items-center justify-center transition-all ${checked ? 'bg-emerald-600 border-emerald-600' : 'border border-slate-300 group-hover:border-emerald-500'}`}>
        {checked && <i className="ri-check-line text-xs text-white" />}
      </div>
      <span className={`sm:text-sm text-xs ${checked ? 'text-slate-700' : 'text-slate-500'}`}>{label}</span>
    </label>
  );
}
